import { memo, useCallback, useEffect, useState } from 'react';
import { BzHeading, BzModal, BzModalBody, BzModalHeader, BzCard, BzModalTitle, BzLoader, BzToolTip } from "../../components";
import { Row, Col, Container, ModalBody } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { FACILITY_NUM, TL_INDEX, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import dayjs from 'dayjs';
import { _handleTimeDifference } from '../../controllers';
import { useMemo } from 'react';
import { useWFHMessages } from '../../hooks';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import ZeroStates from '../ZeroStates';
import { sendTouchlineRequest } from '../../apis/web_socket';
import { convertDateToSeconds, convertScripResponseWatchlistGrid, deepClone, getApiExchangeNameFromMktSegId, getMappedMktSegIdFromApiExchangeName, getMktSegIdFromMappedMktSegId, getScripDisplayDescription, isUserIsAGuest, removeExpiriedScrip } from '../../utils/global_functions';
import { setArrScripToBeAdded } from '../../redux/actions/globalSearch';
import { setScripOverviewData } from '../../redux/actions/marketOverview';
import { toastConfig } from '../../redux/actions/toast';
import { setIsIndicesOverview } from '../../redux/actions/indices';
import { getExchangeWiseScripInfo, getScripOrderInfo, getSpreadOrder } from '../../redux/actions/orders';

const NewsDetailsModal = ({ activeNews, selectedNews, setSelectedNews, tab }) => {

    const dispatch = useDispatch();
    const newsDetails = useSelector(state => state?.news?.newsDetails);
    const hotPursuitData = useSelector(state => state?.news?.hotPursuitData);
    const otherNews = useSelector(state => state?.news?.otherNews);
    const dontMissData = useSelector(state => state?.dontMiss?.dontMissData);
    const modals = useSelector(state => state?.modals?.modals);
    const modalData = useSelector(state => state?.modals?.modalData);
    const isRequestFailed = useSelector(state => state?.news?.isRequestFailed);
    // Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start
    const bIsSectorWiseNewsDetailsApiPending = useSelector(state => state?.news?.bIsSectorWiseNewsDetailsApiPending);
    // Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End
    const arrHotPursuitData = useSelector(state => state?.news?.arrHotPursuitData);
    const arrHoldings = useSelector(state => state?.holdings?.holdingsScrips);


    const [arrDontMiss, setArrDontMiss] = useState([]);
    const [objDetailedHotPursuit, setObjDetailedHotPursuit] = useState({});
    const [arrOthersData, setArrOthersData] = useState([]);
    const [isShowMore, setIsShowMore] = useState(false);
    //Vaibhav Singh: 22-11-23: BT-107439 : Optimisation In Modal : Start
    const [isModalTrue, setIsModalTrue] = useState(false);
    //Vaibhav Singh: 22-11-23: BT-107439 : Optimisation In Modal : End

    const objCFT = useSelector(state => state?.auth?.objCFT);
    const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);
    const [arrRowData, setArrRowData] = useState([]);

    useEffect(() => {
        if (tab === "Hot Pursuit") {
            if (selectedNews && Object.keys(selectedNews) && selectedNews?.scripInfo) {
                setArrRowData(convertScripResponseWatchlistGrid([selectedNews?.scripInfo]));
            } else if (modalData?.newsData && Object.keys(modalData?.newsData)?.length > 0) {
                let nSegmentId = modalData?.newsData.ScripData_NSE !== "-" ? modalData?.newsData?.ScripData_NSE?.MarketSegmentId : modalData?.newsData?.ScripData_BSE !== "-" ? modalData?.newsData?.ScripData_BSE?.MarketSegmentId : null;
                let nToken = modalData?.newsData.ScripData_NSE !== "-" ? modalData?.newsData?.ScripData_NSE?.ODINCode : modalData?.newsData?.ScripData_BSE !== "-" ? modalData?.newsData?.ScripData_BSE?.ODINCode : null;
                const scripInfo = arrHoldings.find((each) => each.nMarketSegmentId + "-" + each.nToken === nSegmentId + "-" + nToken);
                setArrRowData(convertScripResponseWatchlistGrid(scripInfo?.ScripData));
            }
        } else if (tab === "newsAndAnnouncement") {
            setArrRowData([scripOverviewData])
        } else { }
    }, [selectedNews, modalData, tab]);


    useEffect(() => {
        if (modalData?.newsData && Object.keys(modalData?.newsData)?.length > 0 && modalData?.newstype === "hotPursuit") {
            setObjDetailedHotPursuit({ ...modalData?.newsData });
            setArrOthersData(modalData?.newsData?.otherData);
        }
        else if (activeNews) { //Mahesh S: BT-107375 - Scrip Info Events -Active Newss Added
            const clone = deepClone(hotPursuitData);
            if (clone?.length) {
                const sortedArray = clone?.sort((a, b) => (a?.SNo === activeNews?.SNo) ? -1 : (b?.SNo === activeNews?.SNo) ? 1 : 0);
                setObjDetailedHotPursuit(sortedArray[0]);
                setArrOthersData(sortedArray?.slice(1));
            }
        } else {
            setObjDetailedHotPursuit(hotPursuitData[0]);
            setArrOthersData(otherNews);
        }
    }, [hotPursuitData, otherNews, activeNews, modalData]);


    // Hari K : BT : 107439 dashboard-news dontmiss show more functionality functionality-start
    useEffect(() => {
        if (isShowMore) {
            setArrDontMiss(dontMissData);
        } else {
            const arrRowWiseDontMiss = dontMissData.slice(0, 6);
            setArrDontMiss(arrRowWiseDontMiss);
        }
    }, [isShowMore, dontMissData]);
    // Hari K : BT : 107439 dashboard-news dontmiss show more functionality functionality-end
    // SrikanthRao : BT : 107439 dashboard-news - Scrool issue solved15-05-2024-start
    const handleOtherNewsClick = (objOtherNews) => {
        const targetDiv = document.getElementById("modalBody");
        setObjDetailedHotPursuit(objOtherNews);
        targetDiv.scrollTop = 0;
    };
    // SrikanthRao : BT : 107439 dashboard-news - Scrool issue solved15-05-2024-end

    //Vaibhav Singh : BT-107439: 17-11-23: Modal reappearing issue Fixed: Start
    const handleClose = () => {
        setIsShowMore(false);
        dispatch(handleModal([{ "HOT_PURSUIT_DATA": false }, { "NEWS_DETAILS": false }]));

    };
    //Vaibhav Singh : BT-107439: 17-11-23: Modal reappearing ssue Fixed: End

    useEffect(() => {
        if (dontMissData.length > 0 && modals['NEWS_DETAILS']) {
            const arrSubscriptionScrips = dontMissData?.map(scrip => ({ exchangeId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scrip[WATCHLIST_GRID_INDEX.TOKEN] }));
            sendTouchlineRequest(arrSubscriptionScrips);
        } else { }
    }, [dontMissData, modals]);
    //Vaibhav Singh: 22-11-23: BT-107439 : Optimisation In Modal : Start
    useEffect(() => {
        if (modals["HOT_PURSUIT_DATA"]) {
            setIsModalTrue(true);
        } else if (modals['NEWS_DETAILS']) {
            setIsModalTrue(true);
        }
        else {
            setIsModalTrue(false);
        }
    }, [modals['HOT_PURSUIT_DATA']]);
    //Vaibhav Singh: 22-11-23: BT-107439 : Optimisation In Modal : End

    const updateScripWithTouchlineData = (arrTouchLineData) => {
        setArrDontMiss(arrDontMiss => {
            if (arrDontMiss?.length > 0) {
                const nIndex = arrDontMiss?.findIndex(scrip => scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === arrTouchLineData[TL_INDEX.SEGMENT_ID]?.toString() + '_' + arrTouchLineData[TL_INDEX.TOKEN]?.toString());
                if (nIndex >= 0) {
                    const arrScripToBeUpdated = arrDontMiss[nIndex];
                    if (arrScripToBeUpdated && arrScripToBeUpdated?.length > 0) {
                        //By HiralK : 06-09-2023 : For Price optimization - Start
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LTP_PERCENT] = arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
                        //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
                        // const nAbsPrevColse = (arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]);//.toFixed(arrScripToBeUpdated[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                        // //By HiralK : 06-09-2023 : For Price optimization - End
                        // if (nAbsPrevColse > 0) {
                        //     arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = '+' + nAbsPrevColse.toString();
                        // } else if (nAbsPrevColse < 0) {
                        //     arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = nAbsPrevColse.toString();
                        // }
                        // else {
                        //     arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = nAbsPrevColse.toString();
                        // }
                        //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.BID_PRICE] = arrTouchLineData[TL_INDEX.BUY_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.BID_PRICE_INDICATOR] = arrTouchLineData[TL_INDEX.BUY_PRICE_INDICATOR];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] = arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.BID_QUANTITY] = arrTouchLineData[TL_INDEX.BUY_QTY];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASK_PRICE] = arrTouchLineData[TL_INDEX.SELL_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASK_PRICE_INDICATOR] = arrTouchLineData[TL_INDEX.SELL_PRICE_INDICATOR];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ASK_QTY] = arrTouchLineData[TL_INDEX.SELL_QTY];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.HIGH] = arrTouchLineData[TL_INDEX.HIGH_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.LOW] = arrTouchLineData[TL_INDEX.LOW_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.OPEN] = arrTouchLineData[TL_INDEX.OPEN_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.CLOSE] = arrTouchLineData[TL_INDEX.CLOSE_PRICE];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.VOLUME] = arrTouchLineData[TL_INDEX.VOLUME];
                        arrScripToBeUpdated[WATCHLIST_GRID_INDEX.ATP] = arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE];
                        arrDontMiss[nIndex] = arrScripToBeUpdated;
                    } else { }
                } else { }
            } else { }
            return [...arrDontMiss];
        });
    };

    useWFHMessages('touchline', (e) => {
        updateScripWithTouchlineData([...e.detail]);
    });

    useEffect(() => {
        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        if (dontMissData?.length > 0) {
            dontMissData?.forEach((item) => {
                const key = item[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + item[WATCHLIST_GRID_INDEX.TOKEN];
                const arrLastTickData = objLastTickData[key];
                if (arrLastTickData?.length > 0) {
                    updateScripWithTouchlineData([...arrLastTickData]);
                }
                else {
                }
            });
        }

    }, [dontMissData, isShowMore, modals, dispatch]);


    const formatedDate = useMemo(() => {
        if (objDetailedHotPursuit && Object.keys(objDetailedHotPursuit)?.length) {
            return dayjs(`${objDetailedHotPursuit?.Date?.split(' ')[0]} ${objDetailedHotPursuit?.Time}`, { format: "MM/DD/YYYY h:mm A" })?.format("DD MMM'YY h:mm A");
        } else { }
    }, [objDetailedHotPursuit]);

    const handleOverview = useCallback(async () => {
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (isNotExpired) {
            setIsShowMore(false);
            dispatch(handleModal([{ "HOT_PURSUIT_DATA": false }, { "NEWS_DETAILS": false }]));
            await dispatch(setScripOverviewData([...arrRowData[0]]));
            await dispatch(handleModalData({ tab: 'overview', rowDetails: arrRowData[0], mktSegmentToken: getMktSegIdFromMappedMktSegId(arrRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID]) + '_' + arrRowData[WATCHLIST_GRID_INDEX.TOKEN] }));
            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
        } else {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
        }
    }, [arrRowData, selectedNews]);

    const handleAddToWatchlist = () => {
        dispatch(setArrScripToBeAdded(arrRowData));
        dispatch(handleModal([{ 'GLOBAL_SEARCH_ADDSCRIP_MODAL': true }], true));
    };

    const handleChart = () => {
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (isNotExpired) {
            dispatch(handleModal([{ "HOT_PURSUIT_DATA": false }, { "NEWS_DETAILS": false }]));
            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
            dispatch(setScripOverviewData(arrRowData[0]));
            dispatch(handleModalData({ tab: 'analysis' }));
            dispatch(setIsIndicesOverview(false));
        } else {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
        }
    };

    const handleSetAlert = (scrip) => {
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(scrip[0][WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (!isNotExpired) {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
            return;
        }
        setTimeout(() => {
            dispatch(toastConfig({}));
        }, 50);
        dispatch(handleModalData({
            AlertData: {
                symbol: scrip[0][WATCHLIST_GRID_INDEX.SYMBOL],
                exchange: scrip[0][WATCHLIST_GRID_INDEX.EXCHANGE],
                series: scrip[0][WATCHLIST_GRID_INDEX.INSTRUMENT]?.substring(0, 2),
                description: getScripDisplayDescription(scrip),
                token: scrip[0][WATCHLIST_GRID_INDEX.TOKEN],
                mktId: scrip[0][WATCHLIST_GRID_INDEX.SEGMENT_ID],
                mappedMktId: scrip[0][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                decimalLocator: scrip[0][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                decimalLocator_length: scrip[0][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                exchange_segement: getApiExchangeNameFromMktSegId(scrip[0][WATCHLIST_GRID_INDEX.SEGMENT_ID]),
                expiryDate: scrip[0][WATCHLIST_GRID_INDEX.EXPIRYDATE],
                instrument: scrip[0][WATCHLIST_GRID_INDEX.INSTRUMENT],
            },
            isShowAlerts: true
        }));

        dispatch(handleModal([{ "SET_ALERT_MODAL": true }], true));
    };

    const onBuySellClick = useCallback((strBuySell, activeExchangeName = 'NSE') => {
        if((!isUserIsAGuest('buy_sell'))){
            if (arrRowData[0]?.[WATCHLIST_GRID_INDEX?.NSPREAD] == 1) {
                var spreadPaylod =
                {
                    "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(arrRowData[0][WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API,
                    "symbol": arrRowData[0][WATCHLIST_GRID_INDEX.SYMBOL],
                    "token": arrRowData[0][WATCHLIST_GRID_INDEX.TOKEN]
                };
                sendTouchlineRequest([
                    { exchangeId: arrRowData[0][WATCHLIST_GRID_INDEX.SEGMENT_ID], token: arrRowData[0][WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true },

                ]);
                dispatch(getSpreadOrder(spreadPaylod));
                dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));
                dispatch(handleModalData({ data: { spreadArr: arrRowData[0], orderEntryTab: 'multi_scrip', activeTabKey: 'spread' } }), true);
                dispatch(handleModal([{ "HOT_PURSUIT_DATA": false }, { "NEWS_DETAILS": false }]));
            } else {
                dispatch(getScripOrderInfo({ isBuySell: strBuySell === 'BUY' ? 0 : 1, activeExchangeId: arrRowData[0][WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: arrRowData[0] }));
                dispatch(getExchangeWiseScripInfo(arrRowData[0]));
                dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));
                dispatch(handleModal([{ "HOT_PURSUIT_DATA": false }, { "NEWS_DETAILS": false }]));
            }
        }
    }, [arrRowData]);


    return (
        <>
            {/* Vaibhav Singh: 22-11-23: BT-107439 : Optimisation In Modal : Start */}
            <Container fluid className='p-0'>
                <BzModal className='modal-breeze' size={modals['NEWS_DETAILS'] ? 'md' : 'lg'} show={isModalTrue} onHide={handleClose} centered>
                    <BzModalHeader className='modaltabs-header'>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col md={11} className='d-flex justify-content-start align-self-center'>
                                    <BzModalTitle className='font-medium font-size4 color-text'>News Details</BzModalTitle>
                                </Col>
                                <Col md={1} className='d-flex justify-content-end align-self-center'>
                                    <div className='icon-16 icon-close icon-dark' onClick={handleClose}>&nbsp;</div>
                                </Col>
                            </Row>
                        </Container>
                    </BzModalHeader>
                    {/* Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start */}
                    {bIsSectorWiseNewsDetailsApiPending ?
                        <ModalBody className='h_300'>
                            <Row className='g-0 mb-2'>
                                <Col>
                                    <div className='d-flex justify-content-center align-items-center data-loader'>
                                        <BzLoader spinner={bIsSectorWiseNewsDetailsApiPending} spinnerContent="Fetching Details" bIsFfromModal={true} />
                                    </div>
                                </Col>
                            </Row>
                        </ModalBody>
                        //  Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
                        : <BzModalBody id={"modalBody"}>
                            {(modals['NEWS_DETAILS']) ?
                                <>
                                    {newsDetails.length ?
                                        <Container fluid className='p-0 mb-2'>
                                            <Row className='g-0 mb-2'>
                                                <Col>
                                                    <BzHeading className='font-medium font-size4 color-text'>{newsDetails[0]?.Heading}</BzHeading>
                                                </Col>
                                            </Row>
                                            <Row className='g-0 mb-2'>
                                                <Col>
                                                    <div className='font-regular font-size2 color-subtext'>{_handleTimeDifference(newsDetails[0]?.Date)}</div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0 mb-2'>
                                                <Col>
                                                    <div className='font-regular font-size2 color-text' dangerouslySetInnerHTML={{ __html: newsDetails[0]?.ArtText }}></div>
                                                </Col>
                                            </Row>
                                        </Container>

                                        : newsDetails.length <= 0 && isRequestFailed === true ?
                                            <div className='zero-state-alerts zero-state-alerts-lg'>
                                                <ZeroStates subText="Uh oh! Looks like we missed something." isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                <div className='font-regular font-size2 color-nodata text-center'>Let us fix the problem and get back.</div>
                                            </div>
                                            : null}
                                </>
                                :
                                <>
                                    {modalData?.newsData && Object.keys(modalData?.newsData)?.length > 0 || (hotPursuitData && hotPursuitData?.length > 0) ?
                                        <Container fluid className='p-0'>
                                            <Row className='g-0 mb-2'>
                                                <Col className='d-flex justify-content-start align-items-start'>
                                                    <BzHeading className='font-medium font-size4 color-text'>{objDetailedHotPursuit?.Heading}</BzHeading>
                                                </Col>
                                                <Col md={5} className='d-flex justify-content-end align-items-start'>
                                                    <BzToolTip placement={'bottom'} TooltipMsg={'Overview'}>
                                                        <button className={`btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2 ${arrRowData?.length ? '' : 'disabled'}`} onClick={handleOverview}>
                                                            <div class="icon-16 icon-eye icon-primary"></div>
                                                        </button>
                                                    </BzToolTip>
                                                    <BzToolTip placement={'bottom'} TooltipMsg={'Chart'}>
                                                        <button className={`btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2 ${arrRowData?.length ? '' : 'disabled'}`} onClick={handleChart}>
                                                            <div class="icon-16 icon-graph icon-primary"></div>
                                                        </button>
                                                    </BzToolTip>
                                                    {
                                                        objCFT.ALERT === FACILITY_NUM.ON && (
                                                            <BzToolTip placement={'bottom'} TooltipMsg={'Alert'}>
                                                                <button className={`btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2 ${arrRowData?.length ? '' : 'disabled'}`} onClick={handleSetAlert?.bind(this, arrRowData)}>
                                                                    <div class="icon-16 icon-alert icon-primary"></div>
                                                                </button>
                                                            </BzToolTip>)}
                                                    <BzToolTip placement={'bottom'} TooltipMsg={'Add to watchlist'}>
                                                        <button className={`btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2 ${arrRowData?.length ? '' : 'disabled'}`} onClick={handleAddToWatchlist}>
                                                            <div class="icon-16 icon-add-circle icon-primary"></div>
                                                        </button>
                                                    </BzToolTip>
                                                    <button onClick={() => onBuySellClick('BUY')} className={`btn btn-sm btn-positive text-uppercase me-2 ${arrRowData?.length ? '' : 'disabled'}`}>&nbsp;B&nbsp;</button>
                                                    <button onClick={() => onBuySellClick('SELL')} className={`btn btn-sm btn-negative text-uppercase ${arrRowData?.length ? '' : 'disabled'}`}>&nbsp;S&nbsp;</button>
                                                </Col>
                                            </Row>
                                            <Row className='g-0 mb-2'>
                                                <Col>
                                                    <div className='font-regular font-size2 color-subtext'>{formatedDate}</div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0 mb-2'>
                                                <Col>
                                                    <div className='font-regular font-size2 color-text' dangerouslySetInnerHTML={{ __html: objDetailedHotPursuit?.ArtText }}></div>
                                                </Col>
                                            </Row>
                                            {/* {modals['MARKET_OVERVIEW_MODAL'] === true ? '' :

                                                (arrDontMiss && arrDontMiss?.length > 0 ?
                                                    <Row className='g-0 mb-3'>
                                                        <div className='flex-column news-modal-cardwrap '>
                                                            <Row className='g-0 mb-2'>
                                                                <Col className='d-flex justify-content-start align-items-center'>
                                                                    <div className='font-medium font-size4 color-text'>Don't miss out</div>
                                                                    <div className='number-badge-warning ms-2'>{dontMissData?.length}</div>
                                                                </Col>
                                                            </Row>
                                                            <Row className='g-0 mb-2'>
                                                                {arrDontMiss?.length && arrDontMiss?.map((each, i) => (
                                                                    <Col key={each[1]} md={2} className='mb-4'>
                                                                        <BzCard>
                                                                            <div className='d-flex chips-wrap mb-1'>
                                                                                <BzChip className='exchange-chip text-capitalize float-start' onClick={() => handleOtherNewsClick(each)}>{each[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                                                                            </div>
                                                                            <div className='d-flex justify-content-start align-items-center'>
                                                                                <div className='font-medium font-size2 color-text text-uppercase'>{each[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                                                                {holdingsScrips?.length > 0 && holdingsScrips?.some(element => element?.TOTALFREEQUANTITY !== "0" && element?.ISIN === each[WATCHLIST_GRID_INDEX.ISIN_CODE] && each[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) ?
                                                                                    <div className='icon-16 icon-portfolio icon-dark ms-1 pointer-events-none'></div>
                                                                                    : null}
                                                                            </div>
                                                                            <div className='font-regular font-size3 color-text'>{each[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]}</div>
                                                                            <div className={`font-regular font-size2 color-text me-1 ${each[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '+' ? "color-positive" : (each[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '-' ? "color-negative" : '')} `}>{each[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]} ({each[WATCHLIST_GRID_INDEX.LTP_PERCENT]}%)</div>
                                                                        </BzCard>
                                                                    </Col>
                                                                ))}
                                                            </Row>
                                                            <Row className='g-0'>
                                                                <Col className='d-flex justify-content-start align-items-center'>
                                                                    {isShowMore ?
                                                                        <div className='d-flex justify-content-start align-items-center'>
                                                                            <div className='font-medium font-size2 color-textual-link-withicon'>Show less</div>
                                                                            <div class="icon-16 icon-sort-up background-textual-link-withicon ms-1" onClick={() => setIsShowMore(false)}></div>
                                                                        </div>
                                                                        :
                                                                        <div className='d-flex justify-content-start align-items-center'>
                                                                            <div className='font-medium font-size2 color-textual-link-withicon'>Show more</div>
                                                                            <div class="icon-16 icon-sort-down background-textual-link-withicon ms-1" onClick={() => setIsShowMore(true)} ></div>
                                                                        </div>
                                                                    }
                                                                </Col>

                                                            </Row>
                                                        </div>
                                                    </Row> : null)} */}
                                            <Row className='g-0'>
                                                <Col>
                                                    <div className='font-medium font-size2 color-text'>Other News</div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0'>
                                                <Col>
                                                    <div className='otherNews-card-wrap'>
                                                        <div className='d-flex flex-row'>
                                                            {arrOthersData?.length > 0 && arrOthersData?.map((each) => (
                                                                <BzCard className='otherNews-card me-3 mb-2 cursor-pointer' onClick={() => handleOtherNewsClick(each)}>
                                                                    <Row className='g-0 pb-4'>
                                                                        <Col className='otherNews-title'>
                                                                            <div className='font-medium font-size3 color-text news-title-truncate'>{each?.Heading} </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className='g-0'>
                                                                        <Col className='otherNews-info'>
                                                                            <div className='font-medium font-size2 color-text text-wrap'>Powered by Capital Market</div>
                                                                            <div className='font-medium font-size1 color-subtext text-wrap'>{dayjs(`${each?.Date.split(' ')[0]} ${each?.Time}`).format('DD MMM \'YY hh:mm A')} </div>
                                                                        </Col>
                                                                    </Row>
                                                                </BzCard>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                        : (modalData?.newsData && Object.keys(modalData?.newsData)?.length <= 0 && isRequestFailed === true) || (hotPursuitData && hotPursuitData?.length <= 0 && isRequestFailed === true) ?
                                            <div className='zero-state-alerts zero-state-alerts-lg'>
                                                <ZeroStates subText="Uh oh! Looks like we missed something." isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                <div className='font-regular font-size2 color-nodata text-center'>Let us fix the problem and get back.</div>
                                            </div>
                                            : null}
                                </>
                            }
                            {/* Vaibhav Singh: 22-11-23: BT-107439 : Optimisation In Modal : End */}
                        </BzModalBody>}
                </BzModal>
            </Container>
        </>
    );
};

export default memo(NewsDetailsModal);